import React from "react";
import { Panel, TextInput } from "../input";
import { isUpdatedFromDefault } from "../utils";
import { INPUT_LIMITS } from "../input-limits";

function CustomClass({ block, actions, ...props }) {
  const {
    id,
    props: { customClass },
    dom,
  } = block;

  const { setProp } = actions;

  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([{ key: customClass }])}
        id={`block-setting-${id}-custom-class-name`}
        title={"Custom Class Name"}
        initialOpen={false}
      >
        <TextInput
          minLength={INPUT_LIMITS["custom-classname"].minlength}
          maxLength={INPUT_LIMITS["custom-classname"].maxlength}
          isResetVisible={false}
          value={customClass}
          onChange={(val) => {
            setProp((props) => {
              props.customClass = val;
            });
          }}
          label={"Custom Class Name"}
        />
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  if (props.customClass) {
    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
        [props.customClass]: true,
      },
    };
  }
  return supportProps;
}

const supportSchema = {
  id: "grigora/custom-class",
  name: "Custom Class Name",
  component: CustomClass,
  transformProps: transformProps,
};

export default supportSchema;
